<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Multicast Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current multicast profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Multicast Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkAdd()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAllMulticast"
                  />
                  <label for="idSelectAllMulticast"></label>
                </th>
                <th
                  v-for="(value, key) in multicastProfileTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in multicastProfileTable.data"
                :key="row.profileid"
                :class="{ 'true:': true }"
                @click=""
              >
                <td width="40px">
                  <div v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelectMulticast' + index"
                    />
                    <label :for="'idRowSelectMulticast' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileid }}</div>
                </td>
                <td>
                  <div>{{ row.name }}</div>
                </td>
                <td>
                  <div
                    @click="multicastEntry(row.profileid)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!--配置操作-->
          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Multicast Profile Edit'"
              @close="isShowAddTable = false"
              :closeButton="true"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId"
                    >Profile ID</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{ 'has-error': checkProfileID() }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      :disabled="isEditClik"
                      v-model="multicastForm.profileid"
                      placeholder="INTEGER<0-127>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkProfileID() ? 'block' : 'none',
                      }"
                      >{{ checkProfileID() }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name"
                    >Profile Name</label
                  >
                  <div class="col-sm-5" :class="{ 'has-error': checkName() }">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      v-model="multicastForm.name"
                      placeholder="STRING<1-128>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkName() ? 'block' : 'none',
                      }"
                      >{{ checkName() }}
                    </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileMulticast",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      multicastProfileTable: "",
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      select: [],
      iBox: {},
      multicastForm: {
        profileid: "",
        name: "",
      },
    }
  },

  created() {
    this.loadMulticastProfile()
  },

  methods: {
    loadMulticastProfile() {
      get("multicastProfile")
        .then((res) => (this.multicastProfileTable = res.data))
        .catch((err) => {
          this.multicastProfileTable = en.multicastProfileTable
        })
    },

    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },

    clkEdit() {
      for (let i = 0; i < this.multicastProfileTable.data.length; i++) {
        if (this.multicastProfileTable.data[i].selected) {
          this.multicastForm.profileid =
            this.multicastProfileTable.data[i].profileid
          if (
            this.multicastProfileTable.data[i].name.match(/^INDEX_/) == null
          ) {
            this.multicastForm.name = this.multicastProfileTable.data[i].name
          }
          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.multicastProfileTable.data.length; i++) {
        if (this.multicastProfileTable.data[i].selected) {
          list.push({
            aim: Number(this.multicastProfileTable.data[i].profileid),
          })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["profileList"] = list
      post("multicastProfileDelete", delData)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadMulticastProfile()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.loadMulticastProfile()
          this.showAlertBox("critical", "error", err)
        })
    },

    clkCancel() {
      this.isShowAddTable = false
      console.log(this.isShowAddTable)
    },

    resetField() {
      var multicastFormTmp = {
        profileid: "",
        name: "",
      }
      this.multicastForm = multicastFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.multicastProfileTable.data.length; i++) {
        if (this.isSelectAll) {
          this.multicastProfileTable.data[i].selected = true
        } else {
          this.multicastProfileTable.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.multicastProfileTable.data.length; i++) {
        this.multicastProfileTable.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var multicastProfile = {
        profileid: Number(this.multicastForm.profileid),
        name: this.multicastForm.name,
      }
      if (this.isEditClik == false) {
        for (let i = 0; i < this.multicastProfileTable.data.length; i++) {
          if (
            multicastProfile.profileid ==
            this.multicastProfileTable.data[i].profileid
          ) {
            this.showAlertBox(
              "warn",
              "Message",
              "This profile ID has been created"
            )
            return
          }
        }
      }
      if (this.multicastForm.profileid == "" || this.checkProfileID()) {
        this.showAlertBox("warn", "Message", "Invalid profileID")
        return
      }
      if (this.multicastForm.name.length > 128 || this.checkName()) {
        this.showAlertBox("warn", "Message", "Invalid name")
        return
      }

      post("multicastProfileConfig", multicastProfile)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadMulticastProfile()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
      this.selectNull()
    },

    multicastEntry(id) {
      this.$router.push({
        path: "/profilemulticastentry",
        name: "profileMulticastEntry",
        query: { profileId: id },
      })
    },
    checkProfileID() {
      if (this.multicastForm.profileid != "") {
        let profileID = Number(this.multicastForm.profileid)
        if (!isNaN(profileID)) {
          if (profileID < 0 || profileID > 127)
            return "profile ID must be in range 0-127"
        } else return "profile ID must be in range 0-127"
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
    checkName() {
      if (nonASCIIchar(this.multicastForm.name)) {
        return nonASCIIchar(this.multicastForm.name)
      }
      if (this.multicastForm.name.split(" ").length > 1) {
        return "invalid name"
      }
      return null
    },
  },
}
</script>
